import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import CharacterCounter from '../../components/CharacterCounter';

const CharCountPage: React.FC = () => (
  <ToolLayout
    title="Character Counter - Twitter, Instagram & SMS Limits | AllTools"
    description="Count characters with platform-specific limits. Twitter, Instagram, SMS, LinkedIn presets. Free counter."
    canonicalPath="/character-counter"
  >
    <CharacterCounter />
  </ToolLayout>
);

export default CharCountPage;
